export default "__VITE_ASSET__Cs49P17F__"